import { Directive, ElementRef, output } from '@angular/core';

@Directive({
  selector: '[appAfterAddedToDom]',
  standalone: true,
})
export class AfterAddedToDomDirective {
  public readonly appAfterAddedToDom = output<ElementRef>();

  public constructor(private _elementRef: ElementRef) {}

  public ngOnInit(): void {
    this.appAfterAddedToDom.emit(this._elementRef);
  }
}
